<template>
    <Vue100vh class="esport base-page">
        <CircleWrap @click.native="goBack" type="back">
            <BackIconThin/>
        </CircleWrap>
        <div class="top">
            <div class="shadow"></div>
            <div class="stripes"></div>
        </div>
        <div class="content-wrap">
            <div class="responsive-iframe">
                <img src="@/assets/oelteltet/800x450.png"/>
	            <iframe v-if="systemSettings.esportTwitch !== false" :src="'https://player.twitch.tv?channel='+systemSettings.esportTwitch+'&height=300&migration=true&parent=vorbassehjemmemarked.dk&width=400'" allowfullscreen="" scrolling="no" frameborder="0" allow="autoplay; fullscreen" title="Twitch" width="400" height="300"></iframe>
            </div>
            <i class="twitch-info">(Info: Vi oplever på nogle enheder, at Twitch stream ikke fungerer. Hvis du får beskeden, at videoen ikke understøttes i din browser. Så prøv evt. fra en anden enhed, computer eller følg Twitch linket i videoens bund til højre.)</i>
            <div class="page-text-wrap pt0">
                <div class="description">
                    <p><strong>Odense Esport</strong> er super glade over at kunne få muligheden for at være en del af det virtuelle Vorbasse Marked 2020! Vi var fysisk tilstede sidste år, så måske nogle af jer kender os fra der? – I år i dette virtuelle Esport telt får du mulighed for at vinde fede præmier, dyste i forskellige turneringer, få tips og trick og se showkampe!</p>
                    <p>Vi ses online!</p>
                </div>
                <div class="btns-wrap">
                    <div class="row">
                        <div class="col">
                            <button @click="confirmClickToExternal('https://www.youtube.com/playlist?list=PLGAH4qCU20gGfnZLb86WN57xlXQGAcnph')" class="orange">Se tips og tricks</button>
                        </div>
                        <div class="col">
                            <button @click="confirmClickToExternal('https://www.facebook.com/OdenseEsport/')" class="facebook">Følg på Facebook</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Vue100vh>
</template>

<script>
	import Vue100vh from 'vue-div-100vh'
	import CircleWrap from "@/components/CircleWrap"
	import BackIconThin from "@/assets/icons/back-thin.svg"
	import gsap from 'gsap'
	import confirmClickToExternal from "@/mixins/confirmClickToExternal";
	import {mapState} from "vuex";

	export default {
		name: "Esport.vue",
		components: {
			CircleWrap,
			BackIconThin,
			Vue100vh
		},
        mixins:[confirmClickToExternal],
		computed: {
			...mapState('ux', {
				systemSettings: 'systemSettings',
			}),
		},
        mounted(){
	        // Animation
	        let tl = gsap.timeline();
	        tl.to(".esport .top", {delay: 0.5, y: 0, opacity: 1, duration: 0.3});
	        tl.to(".esport .circle", {x: 0, opacity: 1, duration: 0.3});
	        tl.to(".esport .content-wrap", {y: 0, opacity: 1, duration: 0.5, ease: 'power2.easeOut'});
        },
		methods: {
			goBack(){
				this.$router.go(-1)
			}
		}
	}
</script>

<style lang="scss">
    @import "@/assets/scss/_base-page";
    .esport{
        .top{
            .stripes{
                background-color: $black;
                background-image: linear-gradient(90deg, transparent 50%, #F78A06 50%);
            }
        }
        .responsive-iframe{
            margin-bottom: 0px;
        }
        .twitch-info{
            max-width: 800px;
            font-size: 12px;
            line-height: 1.1em;
            display: block;
            margin: 0px auto;
            padding: 30px 0px;
            @media(max-width: 767px){
                padding: 15px;
            }
        }
    }
</style>
